<template>
    <body>
        <HeaderComponent :moduleName="$moduleName" :buildMode="envMode" />
        <main id="main">
            <NovoMenu></NovoMenu>
            <section>
                <router-view />
            </section>
        </main>
        <!-- <Teleport to="body">
            <div v-if="podeBaixarRelatorio" class="fab-relatorio">
                <button
                    type="button"
                    class="acao-secundaria fab-relatorio__btn"
                    :class="{ 'fab-relatorio__btn--carregando': baixandoRelatorio }"
                    :disabled="baixandoRelatorio"
                    :title="baixandoRelatorio ? 'Gerando relatório...' : 'Baixar relatório de faturamento'"
                    @click="baixarRelatorioFaturamento"
                >
                    <i v-if="baixandoRelatorio" class="fa-solid fa-spinner fa-spin"></i>
                    <i v-else class="fa-solid fa-download"></i>
                </button>
            </div>
        </Teleport> -->
    </body>
</template>
<script>
import NovoMenu from './components/menuLateral/MenuLateralComponent.vue'
import { HeaderComponent } from "roboflex-thalamus-componentes-vue3-lib";
import { getPermissao } from '@/services/permissao-service';
import { api } from 'roboflex-thalamus-request-handler';
import { sso } from 'roboflex-thalamus-sso-lib';
import { useToast } from 'vue-toastification';

const aguardar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default {
    data() {
        return {
            envMode: 'production',
            permissoes: [],
            baixandoRelatorio: false,
        }
    },

    components: {
        NovoMenu: NovoMenu,
        HeaderComponent

    },

    setup() {
        const toast = useToast();
        return { toast };
    },

    computed: {
        podeBaixarRelatorio() {
            return this.permissoes.includes(142);
        },
    },

    async mounted() {
        await this.carregarPermissoes();

        if (!this.podeBaixarRelatorio && sso.validarSessao()) {
            await aguardar(500);
            await this.carregarPermissoes();
        }
    },

    methods: {
        async carregarPermissoes() {
            this.permissoes = await getPermissao();
        },

        async baixarRelatorioFaturamento() {
            if (this.baixandoRelatorio) return;

            this.baixandoRelatorio = true;

            try {
                const response = await api.get('comercial/faturamento-lm/download?empresa=todas', {
                    responseType: 'blob',
                });

                const contentDisposition = response.headers['content-disposition'];
                let nomeArquivo = 'faturamento-lm.xlsx';

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (match) nomeArquivo = match[1];
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nomeArquivo);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Erro ao baixar relatório de faturamento:', error);
                this.toast.error('Erro ao baixar o relatório de faturamento.');
            } finally {
                this.baixandoRelatorio = false;
            }
        },
    },
}
</script>
<style>
*::-webkit-scrollbar {
    width: 10px;
}

*::-webkit-scrollbar-thumb {
    background-color: var(--cor-separador);
    border-radius: 20px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-container {
    background-color: var(--cor-bg);
    border-radius: 8px;
    padding: 100px;
    width: 90%;
    max-width: 1500px;
    max-height: 80%;
    /* overflow-y: auto; */
    position: relative;
}

.fab-relatorio {
    position: fixed;
    right: var(--margem);
    bottom: var(--margem);
    z-index: 9999;
}

.fab-relatorio__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px !important;
    height: 44px !important;
    min-width: 44px;
    padding: 0 !important;
    border-radius: 50% !important;
    font-size: 18px;
    line-height: 1;
    color: var(--cor-primaria);
    background: var(--cor-bg) !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
}

.fab-relatorio__btn:not([disabled]):hover {
    color: var(--cor-primaria-forte);
    border-color: var(--cor-primaria);
}

.fab-relatorio__btn[disabled] {
    opacity: 1 !important;
    cursor: wait;
}

.fab-relatorio__btn--carregando {
    color: var(--cor-primaria);
    background: var(--cor-primaria-fraca) !important;
}
</style>
